// extracted by mini-css-extract-plugin
module.exports = {"mainNavbar":"Navbar_mainNavbar__Bu2KX","Navbar":"Navbar_Navbar__3GkUW","main_logo_home_page_div":"Navbar_main_logo_home_page_div__2BEG3","displaynone":"Navbar_displaynone__2tYl_"};